<template>
  <v-container>
    <v-layout v-if="loadingUser === true">
      <v-flex class="loading">
        <pulse-loader :loading="loadingUser"></pulse-loader>
      </v-flex>
    </v-layout>
    <v-layout v-else row wrap class="contact_info" align-center>
      <v-flex xs12>
        <v-card outlined tile flat>
          <v-layout column>
            <v-flex>
              <v-text-field
                label="FIRST NAME (REQUIRED)"
                :rules="[rules.required, rules.minText]"
                v-model="user.name_first"
                :value="user.name_first"
                @input="validateContactInfo(user)"
                required
                outline
              ></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                label="LAST NAME (REQUIRED)"
                :rules="[rules.required, rules.minText]"
                v-model="user.name_last"
                :value="user.name_last"
                @input="validateContactInfo(user)"
                required
                outline
              ></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                label="CELL PHONE (REQUIRED)"
                v-model="user.phone.cell"
                :value="user.phone.cell"
                @input="validateContactInfo(user)"
                :rules="[rules.required, rules.minText, rules.phone]"
                type="phone"
                required
                outline
              ></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                label="ALTERNATE PHONE"
                v-model="user.phone.alt"
                :value="user.phone.alt"
                type="phone"
                outline
              ></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                label="EMAIL ADDRESS (REQUIRED)"
                v-model="user.email"
                :value="user.email"
                @input="validateContactInfo(user)"
                :rules="[rules.required, rules.minText, rules.email]"
                type="email"
                required
                outline
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Shared from "@/mixins/Shared.js";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  name: "ContactInfo",
  mixins: [Shared],
  components: {PulseLoader},
  mounted() {
    this.validateContactInfo(this.user);
  }
}
</script>
